import React, { useEffect, useState } from 'react';

import { hasRoles, CREATE_FORM_ROLES } from '../../../../util/RoleUtil';

import { retrieveForms, viewForm } from '../../../../services/FormService';

import { Table } from '../../../common/table/Table';

import './FormAdministrationSearch.css';

export const FormAdministrationSearch = ({ navigateToWith, context, setSpinnerText, showToaster }) => {
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setSpinnerText('Retrieving Forms');
      const [data, error] = await retrieveForms(context.username);
      if (data) {
        if (data.responseStatus === 'Success') {
          setSearchResults(
            data.forms.map((form) => ({
              ...form,
              studyAllocated: form.studySpecific,
            }))
          );
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }
      setSpinnerText(null);
    };
    fetchData();
  }, [setSpinnerText, context, setSearchResults, showToaster]);

  const handleRowClick = async (form) => {
    setSpinnerText('Retrieving Form');
    const [data, error] = await viewForm(context.username, form.formExternalReference);
    if (data) {
      if (data.responseStatus === 'Success') {
        await navigateToWith('formAdminCreate', '', data);
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  };

  const handleAddButtonClick = () => {
    navigateToWith('formAdminCreate', '', '');
  };

  return (
    <div className="form-administration-search">
      {searchResults && (
        <Table
          tableData={searchResults}
          filterEnabled={true}
          tableTitle={'Form Administration'}
          buttonText={hasRoles(context, CREATE_FORM_ROLES) ? 'Create New' : undefined}
          onButtonClick={handleAddButtonClick}
          buttonOneWidth={'135px'}
          onRowClick={handleRowClick}
          searchEnabled={true}
          maxRowCount={10}
          hiddenColumns={['formExternalReference', 'studySpecific']}
          horizontalScroll
        />
      )}
    </div>
  );
};
